import Phaser from 'phaser';
import { IRoundResult } from '../core/types';
import { Button } from '../ui/Button';

export class ResultScene extends Phaser.Scene {
  private result!: IRoundResult;

  constructor() {
    super('ResultScene');
  }

  init(data: IRoundResult) {
    this.result = data;
  }

  create() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    // Background overlay
    const bg = this.add.graphics();
    bg.fillStyle(0x000000, 0.8);
    bg.fillRect(0, 0, width, height);

    // Title
    let titleText = '🤝 Empate';
    if (this.result && this.result.winnerName) {
        titleText = `🏆 ¡Victoria de ${this.result.winnerName}!`;
    }

    const title = this.add.text(width / 2, height / 4, titleText, {
        fontSize: '48px',
        color: '#d4af37',
        fontStyle: 'bold'
    }).setOrigin(0.5);

    // Score breakdown
    let y = height / 2 - 50;
    if (this.result && this.result.scores) {
        this.result.scores.forEach(score => {
            this.add.text(width / 2, y, `${score.name}: ${score.remainingPips} pts`, {
                fontSize: '24px',
                color: '#ffffff'
            }).setOrigin(0.5);
            y += 40;
        });
    }

    // Buttons
    const btnReplay = new Button(this, width / 2, height - 150, 200, 60, 'Jugar de Nuevo', 'primary', () => {
        this.scene.start('GameScene', { difficulty: 'medium' }); // Keep last difficulty in real implementation
    });
    this.add.existing(btnReplay);

    const btnMenu = new Button(this, width / 2, height - 70, 200, 60, 'Menú', 'secondary', () => {
        this.scene.start('MenuScene');
    });
    this.add.existing(btnMenu);
  }
}
